<template>
    <div class="finance-container">
        <h2>财务总览</h2>
        
        <!-- 财务数据概览 -->
        <div class="finance-overview">
            <div class="overview-item">
                <span class="label">账户总览：</span>
                <span class="value">100258.20</span>
            </div>
            <div class="overview-item">
                <span class="label">收支总金额：</span>
                <span class="value">1005.85元</span>
            </div>
        </div>
        
        <!-- 账户搜索 -->
        <div class="account-search">
            <span class="label">账户：</span>
            <el-input v-model="searchAccount" style="width: 200px; margin-right: 10px;"></el-input>
            <el-button type="primary" size="small">查询</el-button>
            <el-button type="primary" size="small" plain style="margin-left: auto;" @click="openAddAccountDialog">添加账户</el-button>
        </div>
        
        <!-- 账户列表 -->
        <el-table :data="accountList" style="width: 100%" border>
            <el-table-column prop="name" label="账户名称">
            </el-table-column>
            <el-table-column prop="balance" label="余额">
            </el-table-column>
            <el-table-column prop="createTime" label="创建时间">
            </el-table-column>
            <el-table-column prop="updateTime" label="最近更新时间">
            </el-table-column>
            <el-table-column prop="remark" label="备注">
            </el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button type="text" size="small">支出</el-button>
                    <el-button type="text" size="small">查看明细</el-button>
                    <el-button type="text" size="small">编辑</el-button>
                    <el-button type="text" size="small" style="color: #F56C6C;">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="table-pagination">
            <el-pagination @current-change="currentChange" :current-page="1" :page-size="10"
                layout="total, prev, pager, next, jumper" :total="1000">
            </el-pagination>
        </div>
        
        <!-- 提示信息 -->
        <!-- <div class="tips">
            <span style="color: #F56C6C;">删除只能删除无流水账户</span>
        </div>
        <div class="tips">
            <span>双击编辑文本</span>
        </div> -->

        <!-- 添加账户对话框 -->
        <el-dialog
            title="添加账户"
            :visible.sync="addAccountDialogVisible"
            width="500px"
        >
            <el-form :model="addAccountForm" label-width="100px">
                <el-form-item label="账户名称">
                    <el-input v-model="addAccountForm.name" placeholder="请输入账户名称"></el-input>
                </el-form-item>
                <el-form-item label="初始余额">
                    <el-input v-model="addAccountForm.balance" placeholder="请输入初始余额"></el-input>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input
                        v-model="addAccountForm.remark"
                        type="textarea"
                        placeholder="请输入备注"
                        :rows="3"
                    ></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addAccountDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="saveAddAccount">保存</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
export default {
    data() {
        return {
            searchAccount: '',
            addAccountDialogVisible: false,
            addAccountForm: {
                name: '',
                balance: '',
                remark: ''
            },
            accountList: [
                {
                    name: '深圳快马公账',
                    balance: '15520.00',
                    createTime: '2023.3.31 10:20',
                    updateTime: '2023.3.31 10:20',
                    remark: ''
                }
            ]
        }
    },
    methods: {
        openAddAccountDialog() {
            this.addAccountDialogVisible = true;
        },
        saveAddAccount() {
            // 保存逻辑
            console.log('保存数据:', this.addAccountForm);
            // 关闭对话框
            this.addAccountDialogVisible = false;
            // 重置表单
            this.addAccountForm = {
                name: '',
                balance: '',
                remark: ''
            };
        }
    }
}
</script>
<style scoped lang="scss">
.finance-container {
    padding: 20px;

    h2 {
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 20px;
    }

    .finance-overview {
        display: flex;
        margin-bottom: 20px;
        padding-bottom: 15px;
        border-bottom: 1px solid #e4e7ed;

        .overview-item {
            margin-right: 30px;

            .label {
                font-size: 14px;
                color: #606266;
            }

            .value {
                font-size: 14px;
                color: #303133;
                font-weight: 500;
            }
        }
    }

    .account-search {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        padding-bottom: 15px;
        border-bottom: 1px solid #e4e7ed;

        .label {
            font-size: 14px;
            color: #606266;
            margin-right: 10px;
        }
    }

    .tips {
        margin-top: 10px;
        font-size: 12px;
        color: #909399;
    }
}
.table-pagination{
  margin-top: 15px;
  text-align: right;
}
</style>
